import { ReactNode } from 'react'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { NotFound } from 'js/core/NotFound'

type RequireAuthProps = {
    viewer?: string
    site?: string
    canWriteToContainerSubtype?: string
    children?: ReactNode
}

const RequireAuth = ({
    viewer,
    site,
    canWriteToContainerSubtype,
    children,
}: RequireAuthProps) => {
    const { loading, data, error } = useQuery<any>(GET_AUTH, {
        variables: {
            canWriteToContainerSubtype,
        },
    })

    if (loading) {
        return null
    }
    if (error) {
        console.error(error)
        return <NotFound />
    }

    const siteData = data?.site
    if (site && siteData && !siteData[site]) {
        return <NotFound />
    }
    const viewerData = data?.viewer
    if (viewer && viewerData && !viewerData[viewer]) {
        return <NotFound />
    }
    return children ?? null
}

const GET_AUTH = gql`
    query GetAuth($canWriteToContainerSubtype: String) {
        site {
            guid
            chatEnabled
            contentModerationEnabled
            commentModerationEnabled
            editUrlSlugEnabled
        }
        viewer {
            guid
            loggedIn
            isAdmin
            canAccessAdmin(permission: accessAdmin)
            hasFullControl: canAccessAdmin(permission: fullControl)
            hasUserManagement: canAccessAdmin(permission: userManagement)
            hasAccessRequestManagement: canAccessAdmin(
                permission: accessRequestManagement
            )
            publicationRequestManagement: canAccessAdmin(
                permission: publicationRequestManagement
            )
            contentManagement: canAccessAdmin(permission: contentManagement)
            canWriteToContainer(subtype: $canWriteToContainerSubtype)
        }
    }
`

export default RequireAuth
